import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumericTextBoxComponent } from './numerictextbox.component';
import { NumericTextBoxModule } from './numerictextbox.module';
/**
 * NgModule definition for the NumericTextBox component with providers.
 */
export class NumericTextBoxAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NumericTextBoxModule],
    exports: [
        NumericTextBoxModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NumericTextBoxAllModule_tsickle_Closure_declarations() {
/** @type {?} */
NumericTextBoxAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NumericTextBoxAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
